const Downloads = () => import(/* webpackChunkName: "support" */ '@/components/support/downloads')
export default {
  name: 'downloads',
  path: 'downloads',
  redirect: '/downloads/index',
  meta: {label: 'downloads'},
  component: {
    render (c) { return c('router-view') }
  },
  children: [
    {
      path: 'index',
      meta: {label: 'Index'},
      component: Downloads,
      props: true
    }
  ]
}
